module.exports = __webpack_public_path__ + "e95cfc11d5600376771c0f4e74c9654c.png";